export const kContainerClass = "document-container"
// scrollable document content that bounds drags
export const kDragContainerClass = "drag-container"
